$(document).on("click", ".frequency", function(e) {
	e.preventDefault();
	console.log('click')
	$('.frequency').removeClass('selected');
	$(this).addClass('selected')
	var value = $(this).attr('value')
	$('#plan_id').val(value)
	console.log(value)
})